// Where a record came from, as the backend stamps it on each calculation (its `source` filter
// values). One list for the emissions list filter and the Source column, so a source is named
// one way everywhere.
export const EMISSION_SOURCE_OPTIONS: { id: string, name: string }[] = [
  { id: 'MANUAL_ENTRY', name: 'Manual entry' },
  { id: 'API', name: 'API' },
  { id: 'FILE_IMPORT', name: 'File import' },
  { id: 'DOCUMENT_EXTRACTION', name: 'Bill extraction' },
  { id: 'INTEGRATION', name: 'Integration' },
  { id: 'METER_READING', name: 'Meter reading' },
  { id: 'SYSTEM_GENERATED', name: 'System generated' },
]

/** The source's display name. A row with no recorded source counts as manual entry, as the backend's filter does. */
export const emissionSourceName = (source?: string | null): string =>
  EMISSION_SOURCE_OPTIONS.find(option => option.id === (source || 'MANUAL_ENTRY'))?.name || source || ''
